<template>
  <div>
    <CashflowSelect @updated="updated" />
    <h1>Calendar</h1>
    <v-progress-circular indeterminate color="info" v-if="!calendar" />
    <div v-if="calendar">
      <p>
        <a @click="shift(false)">&lt;previous</a>
        <strong>
          <span>{{calendar.startDate | formatDate}}</span>
          <span>&#160;-&#160;</span>
          <span>{{calendar.next | formatDate}}</span>
        </strong>
        <a @click="shift(true)">next&gt;</a>
      </p>
      <div class="cashflowSidebar" v-html="calendar.sidebar" />
      <div class="cashflowScroll" v-html="calendar.scroll" />
      <v-dialog v-model="loadingCalendar" persistent width="300">
        <v-card color="info" dark>
          <v-card-text>
            <span>Waiting for server to produce calendar...</span>
            <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import CashflowSelect from "@/components/cashflow/CashflowSelect";
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "Calendar",
  metaInfo() {
    return {
      title: "Calendar",
      titleTemplate: "%s - Cashflow - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  components: { CashflowSelect },
  data() {
    return { calendar: null, target: null, loadingCalendar: false };
  },
  methods: {
    fetchCalendar() {
      this.loadingCalendar = true;
      nbmlaw
        .get(
          `/cors/admin/directory/entities/current/cashflows/current/calendar`,
          {
            params: { target: this.target }
          }
        )
        .then(response => {
          // console.log(response.data);
          this.calendar = response.data;
          this.loadingCalendar = false;
        })
        .catch(() => {
          this.loadingCalendar = false;
        });
    },
    shift(value) {
      if (value) {
        this.target = this.calendar.next;
      } else {
        this.target = this.calendar.previous;
      }
      this.fetchCalendar();
    },
    updated() {
      this.fetchCalendar();
    }
  },
  created() {
    this.fetchCalendar();
  }
};
</script>

<style>
.paddedContent {
  padding: 5px;
}
.cashflowSidebar {
  float: left;
  width: 140px;
}
.cashflowScroll {
  margin-left: 140px;
  overflow: auto;
  overflow-y: hidden;
  -ms-overflow-y: hidden;
}
.cashflowHeader {
  white-space: pre;
  text-align: center;
}
.cashflowCell {
  text-align: right;
}
.cashflowNegative {
  color: red;
}
</style>